<template>
  <form
    class="ecommerce-form action-buttons-fixed"
    @submit.prevent="submitForm"
    novalidate
  >
    <div class="row">
      <div class="col">
        <section class="card card-modern card-big-info">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-2-5 col-xl-1-5">
                <i class="card-big-info-icon bx bx-dollar-circle"></i>
                <h2 class="card-big-info-title">Billing Info</h2>
                <p class="card-big-info-desc">
                  Add here the customer billing info with all details and
                  necessary information.
                </p>
              </div>
              <div class="col-lg-3-5 col-xl-4-5">
                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Ime</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :class="{ error: $v.firstName.$invalid && $v.$dirty }"
                      v-model="firstName"
                    />

                    <form-error
                      :model="$v.firstName"
                      :dirty="$v.$dirty"
                      label="Ime"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Prezime</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :class="{ error: $v.lastName.$invalid && $v.$dirty }"
                      v-model="lastName"
                    />

                    <form-error
                      :model="$v.lastName"
                      :dirty="$v.$dirty"
                      label="Prezime"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Telefon</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :class="{ error: $v.phoneNumber.$invalid && $v.$dirty }"
                      v-model="phoneNumber"
                    />

                    <form-error
                      :model="$v.phoneNumber"
                      :dirty="$v.$dirty"
                      label="Telefon"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Uloge
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div>
                      <treeselect
                        v-model="userGroups"
                        :multiple="true"
                        :options="roles"
                        :show-count="true"
                        placeholder="Izaberite uloge"
                      />
                    </div>
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Kompanija</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <treeselect
                      v-model="companyId"
                      loadingText="Učitavanje..."
                      :noResultsText="companyNoResultsText"
                      searchPromptText="Unesite najmanje 3 karaktera"
                      :load-options="loadCompanies"
                      :async="true"
                      :options="companies"
                      :cache-options="false"
                      placeholder="Izaberite kompaniju"
                    />

                    <form-error
                      :model="$v.companyId"
                      :dirty="$v.$dirty"
                      label="Kompanija"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Kontakt osoba?
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox-custom checkbox-default">
                      <input
                        type="checkbox"
                        v-model="isContactPerson"
                        id="is-contact-person"
                      />
                      <label for="is-contact-person"></label>
                    </div>
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Titula</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      v-model="personProfessionalTitle"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Država</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <treeselect
                      v-model="countryId"
                      loadingText="Učitavanje..."
                      noResultsText="Nema rezultata"
                      searchPromptText="Unesite državu"
                      :load-options="loadCountries"
                      :async="true"
                      :options="countries"
                      :cache-options="false"
                      placeholder="Izaberite državu"
                      @select="handleCountrySelect"
                    />

                    <form-error
                      :model="$v.countryId"
                      :dirty="$v.$dirty"
                      label="Država"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Grad
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <treeselect
                      v-model="townId"
                      loadingText="Učitavanje..."
                      noResultsText="Nema rezultata"
                      searchPromptText="Unesite grad"
                      :load-options="loadTowns"
                      :cache-options="false"
                      :async="true"
                      :options="towns"
                      placeholder="Izaberite grad"
                      @select="setZipCode"
                    />

                    <form-error
                      :model="$v.townId"
                      :dirty="$v.$dirty"
                      label="Grad"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Interesna područja
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <vue-select
                      :options="interestsAreas"
                      v-model="interestsAreasIds"
                      :close-on-select="false"
                      :multiple="true"
                      track-by="id"
                      label="title"
                      placeholder="Izaberite interesna područja"
                    >
                      <template slot="noOptions">Lista je prazna</template>
                      <template slot="noResult"
                        >Nema rezultata prema zadanim parametrima</template
                      >
                    </vue-select>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary mt-2"
                      @click="selectAllInterestsAreas"
                    >
                      Odaberi sve
                    </button>
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Adresa 1
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :class="{ error: $v.address_1.$invalid && $v.$dirty }"
                      v-model="address_1"
                    />

                    <form-error
                      :model="$v.address_1"
                      :dirty="$v.$dirty"
                      label="Adresa 1"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Adresa 2
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      v-model="address_2"
                    />
                  </div>
                </div>
                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Prima sve notifikacije?
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox-custom checkbox-default">
                      <input
                        type="checkbox"
                        v-model="receivesAllNotifications"
                        id="can-view-prices"
                      />
                      <label for="can-view-prices"></label>
                    </div>
                  </div>
                </div>
                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Može vidjeti finansije?
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox-custom checkbox-default">
                      <input
                        type="checkbox"
                        v-model="canViewFinances"
                        id="can-view-prices"
                      />
                      <label for="can-view-prices"></label>
                    </div>
                  </div>
                </div>
                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Može vidjeti cijene?
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox-custom checkbox-default">
                      <input
                        type="checkbox"
                        v-model="canViewPrices"
                        id="can-view-prices"
                      />
                      <label for="can-view-prices"></label>
                    </div>
                  </div>
                </div>
                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Potrebno odobriti narudžbu?
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox-custom checkbox-default">
                      <input
                        type="checkbox"
                        v-model="orderApprovalRequired"
                        id="order-approval-required"
                        @change="onChangeOrderApprovalRequired"
                      />
                      <label for="order-approval-required"></label>
                    </div>
                  </div>
                </div>
                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Može odobriti narudžbu?
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox-custom checkbox-default">
                      <input
                        type="checkbox"
                        v-model="canApproveOrder"
                        @change="onChangeCanApproveOrder"
                        id="can-approve-order"
                      />
                      <label for="can-approve-order"></label>
                    </div>
                  </div>
                </div>
                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    for="can-view-all-orders-within-company"
                  >
                    Može vidjeti sve narudžbe unutar kompanije?
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox-custom checkbox-default">
                      <input
                        type="checkbox"
                        v-model="canViewAllOrdersWithinCompany"
                        id="can-view-all-orders-within-company"
                      />
                      <label for="can-view-all-orders-within-company"></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <section class="card card-modern card-big-info">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-2-5 col-xl-1-5">
                <i class="card-big-info-icon bx bx-mail-send"></i>
                <h2 class="card-big-info-title">Shipping Info</h2>
                <p class="card-big-info-desc">
                  Add here the customer shipping info with all details and
                  necessary information.
                </p>
              </div>
              <div class="col-lg-3-5 col-xl-4-5">
                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Same as billing</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox">
                      <label class="my-2">
                        <input
                          type="checkbox"
                          v-model="sameAsBilling"
                          data-bs-toggle="collapse"
                          data-bs-target=".shipping-fields-wrapper"
                        />
                        Check this box to use same information as billing for
                        shipping.
                      </label>
                    </div>
                  </div>
                </div>

                <div class="shipping-fields-wrapper collapse show">
                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Ime</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        v-model="shippingInfo.firstName"
                        class="form-control form-control-modern"
                        :class="{
                          error:
                            $v.shippingInfo.firstName.$invalid && $v.$dirty,
                        }"
                      />

                      <form-error
                        :model="$v.shippingInfo.firstName"
                        :dirty="$v.$dirty"
                        label="Ime"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Prezime</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :class="{
                          error: $v.shippingInfo.lastName.$invalid && $v.$dirty,
                        }"
                        v-model="shippingInfo.lastName"
                      />

                      <form-error
                        :model="$v.shippingInfo.lastName"
                        :dirty="$v.$dirty"
                        label="Prezime"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Telefon</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :class="{
                          error: $v.shippingInfo.phone.$invalid && $v.$dirty,
                        }"
                        v-model="shippingInfo.phone"
                      />

                      <form-error
                        :model="$v.shippingInfo.phone"
                        :dirty="$v.$dirty"
                        label="Telefon"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Država</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="shippingInfo.countryId"
                        loadingText="Učitavanje..."
                        noResultsText="Nema rezultata"
                        searchPromptText="Unesite državu"
                        :load-options="loadCountries"
                        :async="true"
                        :options="countries"
                        placeholder="Izaberite državu"
                        @select="handleCountrySelect"
                      />

                      <form-error
                        :model="$v.shippingInfo.countryId"
                        :dirty="$v.$dirty"
                        label="Država"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Grad</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="shippingInfo.townId"
                        loadingText="Učitavanje..."
                        noResultsText="Nema rezultata"
                        searchPromptText="Unesite grad"
                        :load-options="loadShippingTowns"
                        :async="true"
                        :options="towns"
                        placeholder="Izaberite grad"
                        @select="setShippingZipCode"
                      />

                      <form-error
                        :model="$v.shippingInfo.townId"
                        :dirty="$v.$dirty"
                        label="Grad"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Zip kôd</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :class="{
                          error: $v.shippingInfo.zipCode.$invalid && $v.$dirty,
                        }"
                        v-model="shippingInfo.zipCode"
                      />

                      <form-error
                        :model="$v.shippingInfo.zipCode"
                        :dirty="$v.$dirty"
                        label="Zip kôd"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Adresa 1</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :class="{
                          error:
                            $v.shippingInfo.address_1.$invalid && $v.$dirty,
                        }"
                        v-model="shippingInfo.address_1"
                      />

                      <form-error
                        :model="$v.shippingInfo.address_1"
                        :dirty="$v.$dirty"
                        label="Adresa 1"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Adresa 2</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        v-model="shippingInfo.address_2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <section class="card card-modern card-big-info">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-2-5 col-xl-1-5">
                <i class="card-big-info-icon bx bx-user-circle"></i>
                <h2 class="card-big-info-title">Account Info</h2>
                <p class="card-big-info-desc">
                  Add here the customer account info with all details and
                  necessary information.
                </p>
              </div>
              <div class="col-lg-3-5 col-xl-4-5">
                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >E-mail</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="email"
                      class="form-control form-control-modern"
                      :class="{ error: $v.email.$invalid && $v.$dirty }"
                      v-model="email"
                    />

                    <form-error
                      :model="$v.email"
                      :dirty="$v.$dirty"
                      label="E-mail"
                    />
                  </div>
                </div>
                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Korisničko ime</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :class="{ error: $v.username.$invalid && $v.$dirty }"
                      v-model="username"
                    />

                    <form-error
                      :model="$v.username"
                      :dirty="$v.$dirty"
                      label="Korisničko ime"
                    />
                  </div>
                </div>
                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Lozinka</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <div class="d-flex gap-2">
                      <input
                        :type="passwordFieldType"
                        class="form-control form-control-modern"
                        autocomplete="new-password"
                        :class="{ error: $v.password.$invalid && $v.$dirty }"
                        v-model="password"
                      />

                      <button
                        type="button"
                        class="btn btn-primary flex-shrink-0"
                        @click="generatePassword"
                      >
                        Generiši lozinku
                      </button>
                    </div>

                    <form-error
                      :model="$v.password"
                      :dirty="$v.$dirty"
                      label="Lozinka"
                    />
                  </div>
                </div>
                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Potvrda lozinke</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      :type="passwordFieldType"
                      class="form-control form-control-modern"
                      :class="{
                        error:
                          $v.confirmPassword.$invalid &&
                          $v.confirmPassword.$dirty,
                      }"
                      v-model="confirmPassword"
                      autocomplete="new-password"
                    />

                    <form-error
                      :model="$v.confirmPassword"
                      :dirty="$v.$dirty"
                      label="Potvrda lozinke"
                      sameAs="Lozinka"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="row action-buttons">
      <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
        <router-link
          exact
          :to="{ name: 'Users' }"
          class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
        >
          {{ translations.cancel }}
        </router-link>
        <button
          type="submit"
          class="btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          data-loading-text="Loading..."
        >
          <i class="bx bx-save text-4 me-2"></i> Save
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import VueSelect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { debounce } from 'lodash';

import validations from './validation-schema/add';
import api from '@/services/api';
import { translations } from '@/mixins';
import FormError from '../shared/form-errors/FormError.vue';

export default {
  name: 'AddUser',
  components: {
    VueSelect,
    Treeselect,
    FormError,
  },
  validations,
  mixins: [translations],
  data() {
    return {
      interestsAreasIds: [],
      userGroups: [],
      isContactPerson: true,
      personProfessionalTitle: '',
      title: '',
      firstName: '',
      lastName: '',
      username: '',
      phoneNumber: '',
      email: '',
      password: '',
      confirmPassword: '',
      // this will change to text when button to generate password is clicked
      passwordFieldType: 'password',
      address_1: '',
      address_2: '',
      countryId: null,
      townId: null,
      companyId: null,
      zipCode: '',
      sameAsBilling: false,
      canViewPrices: true,
      orderApprovalRequired: false,
      canApproveOrder: false,
      canViewAllOrdersWithinCompany: false,
      shippingInfo: {
        firstName: '',
        lastName: '',
        phone: '',
        address_1: '',
        address_2: '',
        countryId: null,
        townId: null,
        zipCode: '',
      },
      receivesAllNotifications: false,
      canViewFinances: false,
      companySearchQuery: '',
      pendingCompanyCallbacks: [],
    };
  },
  computed: {
    companyNoResultsText() {
      return this.companySearchQuery.length < 3
        ? 'Unesite najmanje 3 karaktera'
        : 'Nema rezultata';
    },
    companies() {
      return this.$store.getters.getCompanies.map((item) => {
        return {
          id: item.id,
          label: item.title,
          ...item,
        };
      });
    },
    countries() {
      return this.$store.getters.getCountries.map((item) => {
        return {
          id: item.id,
          label: item.title,
          ...item,
        };
      });
    },
    towns() {
      return this.$store.getters.getTowns.map((item) => {
        return {
          id: item.id,
          label: item.title,
          ...item,
        };
      });
    },
    shippingTowns() {
      return this.$store.getters.getShippingTowns;
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
    roles() {
      return this.$store.getters.getRolesSimplified.map(({ id, name }) => ({
        id,
        label: name,
      }));
    },
    interestsAreas() {
      return this.$store.getters.getInterestsAreas.map(({ id, title }) => ({
        id,
        title,
      }));
    },
  },
  methods: {
    selectAllInterestsAreas() {
      this.interestsAreasIds = [...this.interestsAreas];
    },
    onChangeCanApproveOrder() {
      this.orderApprovalRequired = false;
    },
    onChangeOrderApprovalRequired() {
      this.canApproveOrder = false;
    },
    handleCountrySelect({ id }) {
      this.$store.dispatch('getTowns', {
        isSortAscending: true,
        retrieveAll: true,
        sortBy: 'title',
        countryId: id,
      });
    },
    getShippingTowns() {
      this.$store.dispatch('getShippingTowns', {
        countryId: this.shippingInfo.countryId,
      });
      this.shippingInfo.townId = null;
    },
    setZipCode({ id }) {
      this.zipCode = this.towns.find((town) => town.id === id).zipCode;
    },
    setShippingZipCode({ id }) {
      this.shippingInfo.zipCode = this.towns.find(
        (town) => town.id === id
      ).zipCode;
    },
    submitForm() {
      this.$v.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const {
        firstName,
        lastName,
        username,
        phoneNumber,
        email,
        password,
        address_1,
        address_2,
        townId,
        countryId,
        companyId,
        sameAsBilling,
        zipCode,
        isContactPerson,
        personProfessionalTitle,
        userGroups,
        interestsAreasIds,
        canViewPrices,
        orderApprovalRequired,
        canApproveOrder,
        receivesAllNotifications,
        canViewFinances,
        canViewAllOrdersWithinCompany,
      } = this;
      let { shippingInfo } = this;

      if (sameAsBilling) {
        shippingInfo = {
          firstName,
          lastName,
          username,
          phone: phoneNumber,
          address_1,
          address_2,
          townId,
          zipCode,
          countryId,
        };
      }

      api
        .addUser({
          isContactPerson,
          personProfessionalTitle,
          firstName,
          lastName,
          username,
          phoneNumber,
          email,
          password,
          address_1,
          address_2,
          companyId,
          townId,
          userGroups,
          canViewPrices,
          orderApprovalRequired,
          canApproveOrder,
          receivesAllNotifications,
          canViewFinances,
          canViewAllOrdersWithinCompany,
          interestsAreas: interestsAreasIds.map(({ id }) => id),
        })
        .then((response) => {
          shippingInfo.userId = response.data.data;
          api
            .addShippingInfo(shippingInfo)
            .then(() => {
              this.$toast.info(response.data.info);
              this.$router.push({ name: 'Users' });
            })
            .catch((err) => {
              this.$toast.error(err?.response?.data?.info || 'Desila se greška');
            });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    loadCompanies({ callback, searchQuery }) {
      this.companySearchQuery = searchQuery || '';

      if (this.companySearchQuery.length < 3) {
        callback(null, []);
        return;
      }

      this.pendingCompanyCallbacks.push(callback);
      this.searchCompanies();
    },
    searchCompanies: debounce(function () {
      const callbacks = this.pendingCompanyCallbacks;
      this.pendingCompanyCallbacks = [];

      this.$store
        .dispatch('getCompaniesV2', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: this.companySearchQuery,
          sortBy: 'title',
        })
        .then(() => {
          callbacks.forEach((cb) => cb(null, this.companies));
        })
        .catch((err) => {
          callbacks.forEach((cb) => cb(err));
        });
    }, 500),
    loadCountries({ callback, searchQuery }) {
      this.$store
        .dispatch('getCountries', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: 'title',
        })
        .then(() => {
          callback(null, this.countries);
        });
    },
    loadTowns({ callback, searchQuery }) {
      this.townId = null;

      this.$store
        .dispatch('getTowns', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: 'title',
          countryId: this.countryId,
        })
        .then(() => {
          callback(null, this.towns);
        });
    },
    loadShippingTowns({ callback, searchQuery }) {
      this.shippingInfo.townId = null;

      this.$store
        .dispatch('getTowns', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: 'title',
          countryId: this.shippingInfo.countryId,
        })
        .then(() => {
          callback(null, this.towns);
        });
    },
    generatePassword() {
      const password = (Math.random() + 1).toString(36).substring(2);

      this.password = password;
      this.confirmPassword = password;

      this.passwordFieldType = 'text';
    },
  },
  mounted() {
    this.$store.dispatch('getCountries', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });

    this.$store.dispatch('getRolesSimplified');
    this.$store.dispatch('getInterestsAreas', { retrieveAll: true });
  },
};
</script>

<style lang="scss">
.form-control.error {
  border-color: #a94442;
}
</style>
